import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { LazyImage } from "@website/ui/lazy-image";
import type { VillaHostStepItem } from "../../villa-host.types";
export const VillaHostStepCard = t0 => {
  const $ = _c(21);
  const {
    icon,
    title,
    items,
    afterIcon,
    beforeIcon
  } = t0;
  let t1;
  if ($[0] !== beforeIcon) {
    t1 = beforeIcon && <LazyImage alt="" src={beforeIcon} className="absolute left-full top-[20%] hidden h-[73px] w-auto -translate-y-1/2 translate-x-2 object-contain lg:block" />;
    $[0] = beforeIcon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon || $[3] !== title) {
    t2 = <LazyImage alt={title} src={icon} className="shrink-0 object-contain" />;
    $[2] = icon;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== afterIcon) {
    t3 = afterIcon && <LazyImage alt="" src={afterIcon} className="absolute right-full top-0 hidden h-[48px] w-auto -translate-x-2 -translate-y-1/2 object-contain lg:block" />;
    $[5] = afterIcon;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex min-h-[88px] items-center justify-center lg:min-h-[112px]"><div className="relative inline-flex items-center justify-center">{t1}{t2}{t3}</div></div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== title) {
    t5 = <div className="text-sm font-medium lg:text-base">{title}</div>;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== items) {
    t6 = items.map(_temp);
    $[13] = items;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <ul className="text-on-surface-medium-emphasis pt-4 text-xs lg:text-sm">{t6}</ul>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <div className="flex w-full flex-col items-center text-center">{t4}{t5}{t7}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(item) {
  return <li key={item} className="text-start"><div className="flex items-start gap-2"><MaterialIcon name="check" className="size-4" /><span className="min-w-max">{item}</span></div></li>;
}